<template>
  <el-card class="box-card">
    <div class="download-item-title">
      <h3 class="title">{{params.title}}</h3>
    </div>
    <el-card class="donwload-cursor margin-top-10" v-for="(item,index) in params.childrens" :key="index" shadow="always">
      <div :test_id="'download_' +index" class="download-block" @click="click(item.link)">
        <img class="download-img" src="../../../assets/images/table-down.png">
        <span class="download-title">{{item.title}}</span>
      </div>
    </el-card>
  </el-card>
</template>

<script>
export default {
  props: {
    params: {
      type: Object,
      default: () => {
      }
    }
  },
  data () {
    return {

    }
  },
  methods: {
    click (link) {
      window.open(link)
    }
  }
}
</script>

<style scoped>
.title {
  font-size: 18px;
  color: #182a54;
  border-bottom: 3px solid #ebebeb;
  padding-bottom: 20px;
}
.download-title {
  vertical-align: middle;
  margin-left: 10px;
  display: inline-block;
}
.donwload-cursor{
  cursor: pointer;
}
.el-card__body{
    margin-top: 10px;
}
.download-img {
  height: 36px;
  vertical-align: middle;
}
.icon-font-color {
  color: green;
}
</style>
